module.exports = __webpack_public_path__ + "img/cpzz6@2x.9c636038.png";